import * as Yup from 'yup';
import { AdminAllowanceNames, ContractTypes } from '@pharmaplan/common';
import { commonAllowanceValidations, hourlyRateValidator, longTermContractValidation } from '../../../helpers/commonValidators';

export const SelfApproveValidator = () =>
  Yup.object().shape({
    ...commonAllowanceValidations,
    ...longTermContractValidation,
    displayDate: Yup.string().nullable(),

    [AdminAllowanceNames.pharmacistHourlyRate]: Yup.number().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: hourlyRateValidator,
    }),
  });

const Validator = () =>
  Yup.object().shape({
    pharmacyWeekDayHourlyRate: Yup.number().nullable().when(['contractType', 'weekdayHours'], {
      is: (contractType: ContractTypes, weekdayHours: number) =>
        contractType === ContractTypes.longTerm && weekdayHours > 0,
      then: hourlyRateValidator,
    }),
    pharmacyWeekendHourlyRate: Yup.number().nullable().when(['contractType', 'weekendHours'], {
      is: (contractType: ContractTypes, weekendHours: number) =>
        contractType === ContractTypes.longTerm && weekendHours > 0,
      then: hourlyRateValidator,
    }),
    ...commonAllowanceValidations,
    ...longTermContractValidation,

    displayDate: Yup.string().nullable(),

    [AdminAllowanceNames.pharmacistHourlyRate]: Yup.number().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: hourlyRateValidator,
    }),
    [AdminAllowanceNames.pharmacyHourlyRate]: Yup.number().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: hourlyRateValidator,
    }),
  });

export default Validator;
